// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"898":"9785597d","901":"158f390f"}[chunkId] + ".chunk.css";
};